import { useEffect, useState } from "react";
import api from "@/lib/api";

export function useAiEntitlement() {
  const [state, setState] = useState({ loading: true, aiEnabled: false, mcpAvailable: false });
  useEffect(() => {
    let alive = true;
    api.get("/merchant/entitlements")
      .then((r) => alive && setState({ loading: false, aiEnabled: !!r.data?.ai_enabled, mcpAvailable: r.data?.mcp_available === true }))
      .catch(() => alive && setState({ loading: false, aiEnabled: false, mcpAvailable: false }));
    return () => { alive = false; };
  }, []);
  return state;
}
